<main>
	<!-- DETAILS SECTION  -->
	<ng-container>
		<section>
			<div class="py-36px px-48px rounded-24px w-[872px] bg-off-white m-auto">
				<h1
					*ngIf="!addMode && !editMode && !this.productDetails?.hasVariant"
					class="text-dark-grey text-font-16 font-DIN-Bold font-bold"
				>
					{{ 'STORE.ADD_PRODUCT.SKU' | translate }} :
					<span class="text-medium-gray text-font-16">{{
						this.productDetails?.hasVariant
							? null
							: productDetails?.productVariants[0]?.skuNumber
					}}</span>
				</h1>
				<div class="mb-24px">
					<app-products-slider
						(updateData)="
							getController('gallaryImageUrls')?.setValue($event);
							addMode ? '' : updateProductGalleryImages($event)
						"
						(deleteImgUrl)="deleteImg($event)"
						[ProductData]="getController('gallaryImageUrls')?.value"
						(mainImage)="
							getController('mainImageUrl').setValue($event);
							addMode ? '' : updateProductImage()
						"
						[mainImageDisplay]="getController('mainImageUrl')?.value"
						[mainProductSlider]="true"
					></app-products-slider>
				</div>
				<!-- STATUS   -->
				<div
					class="flex justify-between items-center rounded-12px p-24px bg-main-color-black mb-24px"
				>
					<ng-container>
						<div>
							<p class="text-gradient text-font-18 font-DIN-bold font-bold">
								{{ 'STORE.ADD_PRODUCT.ACTIVATION_STATUS' | translate }}
							</p>
							<p class="text-light-grey text-font-14">
								{{ 'STORE.ADD_PRODUCT.ABILITY_TO_ACTIVATE' | translate }}
							</p>
						</div>
						<div>
							<p
								*ngIf="getController('isActive')?.value"
								class="inline-block text-font-16 text-[#00BA88] mb-0 ltr:mr-[16px] rtl:ml-[16px]"
							>
								{{ 'OFFERS.OFFERS_LIST.ACTIVE' | translate }}
							</p>
							<p
								*ngIf="!getController('isActive')?.value"
								class="inline-block text-font-16 text-medium-gray mb-0 ltr:mr-[16px] rtl:ml-[16px]"
							>
								{{ 'OFFERS.OFFERS_LIST.INACTIVE' | translate }}
							</p>
							<mat-slide-toggle
								(change)="
									this.getController('isActive')?.setValue($event?.checked);
									this.productDetails?.isActive
										? (this.productDetails.isActive = $event?.checked)
										: null;
									addMode ? '' : changeProductActivationStatus($event?.checked)
								"
								[checked]="getController('isActive')?.value"
								class="align-top"
								hideIcon
							>
							</mat-slide-toggle>
						</div>
					</ng-container>
				</div>

				<!-- STATUS  -->
				<!-- VIEW SECTION  -->
				<section *ngIf="!addMode && !editMode">
					<!-- PRODUCT INFORMATION SECTION -->
					<div class="mb-24px">
						<div class="flex justify-between">
							<h1
								class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
							>
								{{ 'STORE.ADD_PRODUCT.PRODUCT_INFORMATION' | translate }}
							</h1>
							<div
								(click)="changeEditMode(false)"
								*ngIf="!editMode"
								class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
							>
								<img
									class="w-5 max-h-5"
									src="assets/images/edit-blue.svg"
									alt=""
								/>
								<p class="text-[#009EF7]">
									{{ 'ACTIONS.EDIT' | translate }}
								</p>
							</div>
						</div>

						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow"
						>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME_EN' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray break-words">
									{{ productDetails?.name?.en }}
								</p>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME_AR' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray break-words">
									{{ productDetails?.name?.ar }}
								</p>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_EN' | translate }}
								</h1>

								<div
									class="break-words"
									[innerHTML]="descriptionDisplayEn"
								></div>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_AR' | translate }}
								</h1>
								<div
									class="break-words"
									[innerHTML]="descriptionDisplayAr"
								></div>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'GENERAL_LABELS.COUNTRY' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{
										translate.currentLang == 'en'
											? productDetails?.country?.name?.en
											: productDetails?.country?.name?.ar
									}}
								</p>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div class="flex my-[12px]">
								<mat-slide-toggle
									[checked]="productDetails?.hasVariant"
									[disabled]="true"
									class="rtl:mr-[8px] ltr-[8px]"
								></mat-slide-toggle>
								<p>
									{{ 'STORE.ADD_PRODUCT.PRODUCT_WITH_VARIANTS' | translate }}
								</p>
							</div>

							<div class="flex my-[12px]">
								<mat-slide-toggle
									[checked]="productDetails?.isNotReturnable"
									[disabled]="true"
									class="rtl:mr-[8px] ltr-[8px]"
								></mat-slide-toggle>
								<p>
									{{ 'STORE.ADD_PRODUCT.IS_NOT_RETURNABLE' | translate }}
								</p>
							</div>
						</div>
					</div>
					<!-- PRODUCT INFORMATION SECTION -->

					<!-- TARGET AUDIENCE SECTION  -->
					<h1
						class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
					>
						{{ 'STORE.ADD_PRODUCT.TARGET_AUDIENCE' | translate }}
					</h1>
					<div
						class="p-24px rounded-12px bg-off-white sectionShadow  {{
							productDetails
								? productDetails.targetAudience?.length <= 1
									? ''
									: 'flex'
								: ''
						}}  mb-24px"
					>
						<div
							*ngIf="productDetails?.targetAudience?.includes(0)"
							class="bg-off-white rounded-6px border-[1px] border-secondry-color-Gray flex  grow items-center justify-center  ltr:mr-[6px] rtl:ml-[6px]  {{
								productDetails
									? productDetails.targetAudience.length <= 1
										? 'w-[50%]'
										: ''
									: ''
							}}"
						>
							<img
								class="w-[30px] my-12px"
								src="./assets/images/female.svg"
								alt=""
							/>
							<p class="mb-0 mx-[10px]">
								{{ 'SCHEMA.TARGET_AUDIENCE.FEMALE' | translate }}
							</p>
						</div>
						<div
							*ngIf="productDetails?.targetAudience?.includes(1)"
							class="bg-off-white rounded-6px border-[1px] border-secondry-color-Gray flex grow items-center justify-center  {{
								productDetails
									? productDetails.targetAudience.length <= 1
										? 'w-[50%]'
										: ''
									: ''
							}}"
						>
							<img
								class="w-[30px] my-12px"
								src="./assets/images/male.svg"
								alt=""
							/>
							<p class="mb-0 mx-[10px]">
								{{ 'SCHEMA.TARGET_AUDIENCE.MALE' | translate }}
							</p>
						</div>
					</div>
					<!-- TARGET AUDIENCE SECTION  -->

					<!-- CATEGORY & BRAND  -->
					<div class="mb-24px">
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
						>
							{{ 'STORE.PRODUCT_DETAILS.CATEGORY_BRAND' | translate }}
						</h1>
						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow"
						>
							<ng-container *ngIf="productDetails?.category">
								<h1 class="text-font-14 text-dark-grey">
									{{ 'STORE.PRODUCT_DETAILS.CATEGORY' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{
										translate.currentLang == 'en'
											? productDetails?.category?.name?.en
											: productDetails?.category?.name?.ar
									}}
								</p>
							</ng-container>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<ng-container *ngIf="productDetails?.subCategory">
								<h1 class="text-font-14 text-dark-grey">
									{{ 'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{
										translate.currentLang == 'en'
											? productDetails?.subCategory?.name?.en
											: productDetails?.subCategory?.name?.ar
									}}
								</p>
							</ng-container>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<ng-container *ngIf="productDetails?.subSubCategory">
								<h1 class="text-font-14 text-dark-grey">
									{{ 'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{
										translate.currentLang == 'en'
											? productDetails?.subSubCategory?.name?.en
											: productDetails?.subSubCategory?.name?.ar
									}}
								</p>
							</ng-container>
							<div
								*ngIf="productDetails?.subSubCategory"
								class="h-[1px] w-full bg-secondry-color-Gray my-8px"
							></div>
							<ng-container *ngIf="productDetails?.brand">
								<h1 class="text-font-14 text-dark-grey">
									{{ 'STORE.PRODUCT_DETAILS.BRANDS' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{
										translate.currentLang == 'en'
											? productDetails?.brand?.name?.en
											: productDetails?.brand?.name?.ar
									}}
								</p>
							</ng-container>
						</div>
					</div>
					<!-- CATEGORY & BRAND  -->

					<!-- PRODUCT NOTES  -->
					<div *ngIf="productDetails?.productNotes" class="mb-24px">
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
						>
							{{ 'STORE.ADD_PRODUCT.PRODUCT_NOTE' | translate }}
						</h1>
						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow min-h-[88px]"
						>
							{{ productDetails?.productNotes }}
						</div>
					</div>
					<!-- PRODUCT NOTES  -->
					<!--  PRICE & DISCOUNT  -->
					<div *ngIf="!productDetails?.hasVariant" class="mb-24px">
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-[]"
						>
							{{ 'STORE.ADD_PRODUCT.INVENTORY_PRICE' | translate }}
						</h1>
						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow"
						>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'GENERAL_LABELS.PRICE' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{ mainProductDetails?.price }}
								</p>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<ng-container *ngIf="mainProductDetails?.discountAmount">
								<div>
									<h1 class="text-font-14 text-dark-grey mb-[3px]">
										{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}
									</h1>
									<p class="text-font-16 text-medium-gray">
										{{ mainProductDetails?.discountAmount }}
									</p>
								</div>
								<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>

								<div>
									<h1 class="text-font-14 text-dark-grey mb-[3px]">
										{{ 'GENERAL_LABELS.TYPE' | translate }}
									</h1>
									<p class="text-font-16 text-medium-gray">
										{{
											mainProductDetails?.isDiscountFixed
												? ('STORE.ADD_PRODUCT.FIXED_PRICE' | translate)
												: ('STORE.ADD_PRODUCT.PERCENTAGE' | translate)
										}}
									</p>
								</div>
							</ng-container>
						</div>
					</div>
					<!-- PRICE & DISCOUNT  -->
					<!-- INVENTORY  -->
					<div *ngIf="!productDetails?.hasVariant" class="mb-24px">
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-[]"
						>
							{{ 'STORE.ADD_PRODUCT.INVENTORY' | translate }}
						</h1>
						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow"
						>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
								</h1>
								<p class="text-font-16 text-medium-gray">
									{{ mainProductDetails?.skuNumber }}
								</p>
							</div>
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<div>
								<h1 class="text-font-14 text-dark-grey mb-[3px]">
									{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}
								</h1>
								<p
									*ngIf="mainProductDetails?.stockCount > 0"
									class="text-font-16 text-medium-gray"
								>
									{{ mainProductDetails?.stockCount }}
								</p>
								<p
									*ngIf="mainProductDetails?.stockCount == 0"
									class="text-font-16 leading-[22px] text-[#B3261E] m-0"
								>
									{{ 'STATUS.OUTOFSTOCK' | translate }}
								</p>
							</div>

							<div class="flex">
								<mat-checkbox
									class="p-0"
									[disabled]="true"
									[checked]="mainProductDetails?.hasLowQuantity"
								></mat-checkbox>
								<p class="text-dark-grey text-font-16 m-0 leading-[37px]">
									{{ 'STORE.ADD_PRODUCT.LOW_QUANTITY' | translate }}
								</p>
							</div>
						</div>
					</div>
					<!-- INVENTORY  -->

					<!--  PRODUCT VARIANTS TABLE  -->
					<ng-container
						*ngIf="
							productDetails?.productVariants?.length > 0 &&
							productDetails?.hasVariant
						"
					>
						<h1 class="text-dark-grey text-font-16 font-DIN-Bold font-bold">
							{{ 'STORE.ADD_PRODUCT.VARIANTS' | translate }}
						</h1>
						<div class="custom-table overflow-x-auto">
							<table class="mat-elevation-z8 bg-transparent w-full relative">
								<thead class="bg-light">
									<tr class="border-b-[1px] border-secondry-color-Gray">
										<td
											class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
										>
											{{ 'STORE.ADD_PRODUCT.VARIANT_NAME' | translate }}
										</td>

										<td
											class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
										>
											{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
										</td>
										<td
											class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
										>
											<!-- {{ 'STORE.ADD_PRODUCT.STOCK' | translate }} -->
											{{ 'STORE.ADD_PRODUCT.PRICE_DISCOUNT' | translate }}
										</td>
										<td
											class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
										>
											{{ 'STORE.ADD_PRODUCT.QUANTITY' | translate }}
										</td>
										<td
											class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
										>
											{{ 'STORE.ADD_PRODUCT.STATUS' | translate }}
										</td>
										<td></td>
									</tr>
								</thead>
								<tbody class="bg-grey-background">
									<ng-container
										*ngFor="
											let variant of productDetails?.productVariants;
											let i = index
										"
									>
										<tr>
											<td
												class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
											>
												<span
													class="flex gap-[12px] items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
												>
													<img
														[src]="attachmentUrl + variant?.mainImageUrl"
														alt=""
														class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
													/>
													<span>
														<span
															*ngIf="translate.currentLang == 'en'"
															class="block whitespace-normal text-dark-grey"
														>
															{{
																variant?.variantName?.en.length > 13
																	? (variant?.variantName?.en | slice : 0 : 13)
																	: variant?.variantName?.en
															}}

															{{
																variant?.variantName?.en.length > 13
																	? '...'
																	: null
															}}
															<!--  -->
														</span>
														<span
															*ngIf="translate.currentLang == 'ar'"
															class="block whitespace-normal text-dark-grey"
														>
															{{
																variant?.variantName?.ar.length > 13
																	? (variant?.variantName?.ar | slice : 0 : 13)
																	: variant?.variantName?.ar
															}}

															{{
																variant?.variantName?.ar.length > 13
																	? '...'
																	: null
															}}
															<!--  -->
														</span>
													</span>
													<span
														*ngIf="variant?.variantType?.id == 1"
														class="h-[24px] w-[24px] rounded-full"
														[style.backgroundColor]="
															variant?.variantTypeSettings || ''
														"
													>
													</span>
													<span
														*ngIf="variant?.variantType?.id == 2"
														class="text-font-14 text-dark-grey"
													>
														<p class="m-0">
															{{ variant?.variantTypeSettings }}
														</p>
													</span>
												</span>
											</td>
											<td
												class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
											>
												{{ variant?.skuNumber }}
											</td>
											<td
												class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
											>
												<h1
													class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
												>
													{{
														productDetails?.country?.id == 103
															? ('CURRENCY.SAR' | translate)
															: ('CURRENCY.EGP' | translate)
													}}
													{{ variant?.price }}
												</h1>
												<p class="text-medium-gray text-font-14">
													<span
														*ngIf="
															variant?.isDiscountFixed &&
															variant?.discountAmount
														"
														>{{ variant?.discountAmount }}
														{{
															productDetails?.country?.id == 103
																? ('CURRENCY.SAR' | translate)
																: ('CURRENCY.EGP' | translate)
														}}</span
													>
													<span
														*ngIf="
															!variant?.isDiscountFixed &&
															variant?.discountAmount
														"
														>{{ variant?.discountAmount }} {{ '% '
														}}{{ 'STORE.ADD_PRODUCT.OFF' | translate }}</span
													>
												</p>
											</td>
											<td
												class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
											>
												<div class="inline-block">
													<p
														*ngIf="
															variant?.stockCount
																? variant.stockCount > 0
																: null
														"
														class="text-font-16 text-dark-grey m-0"
													>
														{{ variant?.stockCount }}
													</p>
													<p
														*ngIf="variant?.stockCount == 0"
														class="text-font-16 leading-[22px] text-[#B3261E] m-0"
													>
														{{ 'STATUS.OUTOFSTOCK' | translate }}
													</p>
												</div>
												<img
													*ngIf="variant?.hasLowQuantity"
													class="inline-block"
													src="./assets/images/arrow_down_red.svg"
													alt=""
												/>
											</td>
											<td
												class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
											>
												<app-status
													[enumData]="productActivationStatus"
													[statusValue]="variant?.isActive ? 0 : 1"
												></app-status>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</ng-container>
					<!--PRODUCT VARIANTS TABLE  -->

					<!-- LINKED PRODUCT TABLE  -->
					<!-- UNCOMMENT WHEN NEEDED  -->
					<!-- <div
						class="custom-table overflow-x-auto"
						*ngIf="productDetails?.relatedProducts?.length > 0"
					>
						<table class="mat-elevation-z8 bg-transparent w-full relative">
							<thead class="bg-light">
								<tr class="border-b-[1px] border-secondry-color-Gray">
									<td
										class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
									>
										{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME' | translate }}
									</td>

									<td
										class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
									>
										{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
									</td>
									<td
										class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
									>
										{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}
									</td>
									<td
										class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
									>
										{{ 'STORE.ADD_PRODUCT.STATUS' | translate }}
									</td>
									<td></td>
								</tr>
							</thead>
							<tbody class="bg-grey-background">
								<ng-container
									*ngFor="let relatedProduct of productDetails?.relatedProducts"
								>
									<tr>
										<td
											class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
										>
											<span
												class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
											>
												<img
													[src]="attachmentUrl + relatedProduct?.mainImageUrl"
													alt=""
													class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
												/>
												<span>
													<span class="block whitespace-normal text-dark-grey">
														{{
															translate.currentLang == 'en'
																? relatedProduct?.name?.en
																: relatedProduct?.name?.ar
														}}
													</span>
												</span>
											</span>
										</td>

										<td
											class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
										>
											<h1
												class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
											>
												{{
													translate.currentLang == 'en'
														? relatedProduct?.currency?.name?.en
														: relatedProduct?.currency?.name?.ar
												}}
												{{ relatedProduct?.price }}
											</h1>
										</td>
										<td
											class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
										>
											{{ relatedProduct?.stockCount }}
										</td>
										<td
											class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
										>
											<app-status
												[enumData]="productActivationStatus"
												[statusValue]="relatedProduct?.isActive ? 1 : 0"
											></app-status>
										</td>

										<td
											class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
										>
											<span
												*ngIf="!viewMode"
												class="inline-block max-mobile:w-[20px] w-[16px] text-end cursor-pointer"
											>
												<svg width="16" height="16" viewBox="0 0 16 16">
													<path
														d="M13.3391 9.65212L12.0456 9.21558C11.7223 9.11857 11.3827 9.31259 11.2857 9.61979C11.2049 9.92699 11.3504 10.2504 11.6576 10.3635L12.9511 10.8001C13.2744 10.9133 13.614 10.7354 13.711 10.412C13.808 10.0887 13.6625 9.7653 13.3391 9.65212Z"
														fill="#4E4B66"
													/>
													<path
														d="M10.1537 5.51295C9.91122 5.27042 9.53935 5.27042 9.29682 5.51295L5.86912 8.95682C5.64276 9.19935 5.65893 9.58739 5.90145 9.81375C6.12781 10.0239 6.49969 10.0239 6.72604 9.81375L10.1537 6.36988C10.3801 6.12735 10.3801 5.75548 10.1537 5.51295Z"
														fill="#4E4B66"
													/>
													<path
														d="M10.7194 11.333C10.6062 11.0096 10.2667 10.8479 9.95946 10.945C9.63609 11.0581 9.47441 11.3977 9.57142 11.7049L10.008 12.9983C10.1211 13.3217 10.4607 13.4834 10.784 13.3702C11.1074 13.257 11.2691 12.9175 11.1559 12.5941L10.7194 11.333Z"
														fill="#4E4B66"
													/>
													<path
														d="M5.28731 3.99259C5.38432 4.31596 5.72385 4.49381 6.04722 4.3968C6.37059 4.29979 6.54844 3.96026 6.45143 3.63689C6.45143 3.62072 6.43526 3.60455 6.43526 3.58838L5.99872 2.29491C5.88554 1.97154 5.546 1.80986 5.2388 1.90687C4.9316 2.00388 4.75375 2.35958 4.85076 2.66678L5.28731 3.99259Z"
														fill="#4E4B66"
													/>
													<path
														d="M2.668 5.65814L3.96147 6.09469C4.28484 6.20787 4.62438 6.03002 4.72139 5.70665C4.83457 5.38328 4.65672 5.04374 4.33335 4.94673L3.03987 4.52635C2.71651 4.41318 2.37697 4.59103 2.27996 4.9144C2.18295 5.23776 2.3608 5.56113 2.668 5.65814Z"
														fill="#4E4B66"
													/>
													<path
														d="M8.44002 4.65598L10.1539 2.94213C10.8653 2.23072 12.0132 2.23072 12.7247 2.94213C13.4361 3.65354 13.4361 4.8015 12.7247 5.51291L11.0108 7.22676C10.7683 7.45312 10.7521 7.84116 10.9785 8.08369C11.2048 8.32621 11.5929 8.34238 11.8354 8.11602C11.8516 8.09986 11.8516 8.09985 11.8677 8.08369L13.5816 6.36983C14.8104 5.23804 14.9074 3.314 13.7756 2.0852C12.6438 0.856402 10.7198 0.759391 9.49097 1.89118C9.4263 1.95585 9.36162 2.02053 9.29695 2.0852L7.5831 3.79905C7.34057 4.02541 7.3244 4.41345 7.55076 4.65598C7.77712 4.89851 8.16516 4.91468 8.40768 4.68832C8.42385 4.68832 8.42385 4.67215 8.44002 4.65598Z"
														fill="#4E4B66"
													/>
													<path
														d="M6.72611 13.2416L8.43996 11.5278C8.66632 11.2853 8.65015 10.8972 8.40762 10.6709C8.18126 10.4607 7.80939 10.4607 7.58303 10.6709L5.86918 12.3847C5.15777 13.0961 4.00981 13.0961 3.2984 12.3847C2.58699 11.6733 2.58699 10.5253 3.2984 9.81393L5.01225 8.0839C5.23861 7.84138 5.22244 7.45334 4.97992 7.22698C4.75356 7.01679 4.38168 7.01679 4.15533 7.22698L2.44147 8.957C1.30968 10.1858 1.40669 12.1098 2.63549 13.2416C3.78345 14.2926 5.56198 14.2926 6.72611 13.2416Z"
														fill="#4E4B66"
													/>
												</svg>
											</span>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div> -->
					<!-- LINKED PRODUCT TABLE  -->
				</section>
				<!-- EDIT SECTION  -->
				<ng-container *ngIf="editMode || addMode">
					<h1
						class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
					>
						{{ 'STORE.PRODUCT_DETAILS.PRODUCT_INFORMATION' | translate }}
					</h1>

					<form [formGroup]="productForm">
						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-24px"
						>
							<!-- NAME FORM GROUP  -->
							<div formGroupName="name">
								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME_EN' | translate }}
									</mat-label>
									<input
										formControlName="en"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="text"
										matInput
										maxlength="150"
										placeholder="{{
											'STORE.ADD_PRODUCT.PRODUCT_NAME_EN' | translate
										}}"
									/>

									<mat-error>
										<validation-message
											[controller]="getController('name')?.get('en')"
											controller_name="STORE.ADD_PRODUCT.PRODUCT_NAME_EN"
										>
										</validation-message>
									</mat-error>
								</mat-form-field>
								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME_AR' | translate }}
									</mat-label>
									<input
										formControlName="ar"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="text"
										matInput
										maxlength="150"
										placeholder="{{
											'STORE.ADD_PRODUCT.PRODUCT_NAME_AR' | translate
										}}"
									/>

									<mat-error>
										<validation-message
											[controller]="getController('name')?.get('ar')"
											controller_name="STORE.ADD_PRODUCT.PRODUCT_NAME_AR"
										>
										</validation-message>
									</mat-error>
								</mat-form-field>
							</div>
							<!-- NAME FORM GROUP  -->

							<!-- DESCRIPTION FORM GROUP  -->
							<div formGroupName="description">
								<div>
									<h2 class="text-dark-grey">
										{{ 'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_EN' | translate }}
									</h2>
									<div class="NgxEditor__Wrapper mb-12px">
										<ngx-editor-menu
											[editor]="descriptionEn"
											[toolbar]="toolbar"
										>
										</ngx-editor-menu>
										<ngx-editor
											[editor]="descriptionEn"
											formControlName="en"
											placeholder="{{
												'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_EN' | translate
											}}"
										></ngx-editor>
									</div>
								</div>
								<div>
									<h2 class="text-dark-grey">
										{{ 'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_AR' | translate }}
									</h2>
									<div class="NgxEditor__Wrapper mb-12px">
										<ngx-editor-menu
											[editor]="descriptionAr"
											[toolbar]="toolbar"
										>
										</ngx-editor-menu>
										<ngx-editor
											[editor]="descriptionAr"
											formControlName="ar"
											placeholder="{{
												'STORE.ADD_PRODUCT.PRODUCT_DESCRIPTION_AR' | translate
											}}"
										></ngx-editor>
									</div>
								</div>
							</div>
							<!-- DESCRIPTION FORM GROUP  -->
							<!-- COUNTRY SECTION  -->
							<mat-form-field
								[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
								class="w-full mb-[16px] text-dark-grey"
								appearance="outline"
							>
								<mat-label class="text-dark-grey">{{
									'GENERAL_LABELS.COUNTRY' | translate
								}}</mat-label>
								<mat-select formControlName="countryId" required>
									<mat-select-trigger class="text-main-color-black">
										{{
											getController('countryId')?.value
												? this.translate.currentLang == 'en'
													? selectedCountry?.name?.en
													: selectedCountry?.name?.ar
												: ''
										}}
									</mat-select-trigger>
									<mat-option
										class="my-2"
										*ngFor="let country of countries"
										[value]="country.id"
										(click)="
											this.relatedProductFilter.countryId = country.id;
											selectedCountry = country;
											countryChange()
										"
									>
										<img
											class="inline ltr:mr-2 rtl:ml-2 w-[40px]"
											[src]="attachmentUrl + country.flagUrl"
											alt="icon"
										/>
										<p class="inline-block">
											{{
												translate.currentLang == 'en'
													? country?.name?.en
													: country?.name?.ar
											}}
										</p>
									</mat-option>
								</mat-select>
							</mat-form-field>
							<!-- COUNTRY SECTION  -->
							<!-- VARIANT TOGGLE -->
							<div class="flex mb-[8px]">
								<mat-slide-toggle
									(change)="hasVarianceChange($event)"
									formControlName="hasVariant"
									class="rtl:mr-[8px] ltr-[8px]"
								></mat-slide-toggle>
								<p>
									{{ 'STORE.ADD_PRODUCT.PRODUCT_WITH_VARIANTS' | translate }}
								</p>
							</div>
							<div class="flex mb-[8px]">
								<mat-slide-toggle
									
									formControlName="isNotReturnable"
									class="rtl:mr-[8px] ltr-[8px]"
								></mat-slide-toggle>
								<p>
									{{ 'STORE.ADD_PRODUCT.IS_NOT_RETURNABLE' | translate }}
								</p>
							</div>
							<!-- VARIANT TOGGLE -->
						</div>
						<!-- TARGET AUDIENCE FORM GROUP  -->
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px"
						>
							{{ 'STORE.ADD_PRODUCT.TARGET_AUDIENCE' | translate }}
						</h1>
						<div class="p-24px rounded-12px bg-off-white sectionShadow mb-24px">
							<div class="flex justify-between">
								<div
									class="border-[1px] w-[48%] {{
										this.getController('targetAudience')?.value?.includes(0)
											? 'border-salon'
											: 'border-secondry-color-Gray'
									}}  px-[8px] py-[14px] rounded-[6px] flex justify-between mr-12px"
								>
									<div class="flex items-center">
										<img
											class="max-w-[26px]"
											src="./assets/images/female.svg"
											alt=""
										/>
										<h1 class="text-font-14 text-dark-grey mb-0">
											{{ 'GENERAL_LABELS.WOMEN' | translate }}
										</h1>
									</div>
									<mat-checkbox
										[checked]="
											this.getController('targetAudience')?.value?.includes(0)
										"
										(change)="selectChange($event, 0)"
									></mat-checkbox>
								</div>
								<div
									class="border-[1px] w-[48%] {{
										this.getController('targetAudience')?.value?.includes(1)
											? 'border-salon'
											: 'border-secondry-color-Gray'
									}}  px-[8px] py-[14px] rounded-[6px] flex justify-between  rtl:mr-12px"
								>
									<div class="flex items-center">
										<img
											class="max-w-[26px]"
											src="./assets/images/male.svg"
											alt=""
										/>
										<h1 class="text-font-14 text-dark-grey mb-0">
											{{ 'GENERAL_LABELS.MEN' | translate }}
										</h1>
									</div>
									<mat-checkbox
										[checked]="
											this.getController('targetAudience')?.value?.includes(1)
										"
										(change)="selectChange($event, 1)"
									></mat-checkbox>
								</div>
							</div>
						</div>
						<!-- TARGET AUDIENCE FORM GROUP  -->

						<!-- Category & Brand FORM GROUP  -->

						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-12px"
						>
							{{ 'STORE.ADD_PRODUCT.CATEGORY_BRAND' | translate }}
						</h1>

						<div
							class="py-12px px-24px rounded-12px bg-off-white sectionShadow mt-24px mb-24px"
						>
							<div class="flex justify-between">
								<!-- CATEGORY  -->
								<div class="w-[49%]">
									<h1
										class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
									>
										{{ 'STORE.ADD_PRODUCT.CATEGORY' | translate }}
									</h1>

									<mat-form-field
										appearance="outline"
										class="w-full custom-autocomplete"
									>
										<mat-select
											panelClass=" my-0 mx-24px  {{
												editMode
													? 'custom-ed-hight'
													: 'custom-hight custom-width'
											}} "
											placeholder="{{
												'STORE.ADD_PRODUCT.CATEGORY' | translate
											}}"
											formControlName="categoryId"
										>
											<mat-select-trigger class="text-main-color-black">
												{{
													getController('categoryId')?.value
														? this.translate.currentLang == 'en'
															? categoryvalue?.name?.en
															: categoryvalue?.name?.ar
														: ''
												}}
											</mat-select-trigger>
											<div class="select-container">
												<mat-form-field
													class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
													appearance="outline"
												>
													<div>
														<img
															class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
															src="./assets/images/search-normal.svg"
															alt=""
														/>
													</div>
													<input
														matInput
														type="text"
														(keydown)="$event.stopPropagation()"
														[formControl]="categoryKeyWord"
														placeholder="{{ 'OFFERS.SEARCH' | translate }}"
														class="absolute w-[92%] ltr:left-10 rtl:right-10"
													/>
													<img
														*ngIf="categoryKeyWord.value"
														(click)="categoryKeyWord.setValue('')"
														class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
														src="./assets/images/close-square.svg"
														alt=""
													/>
												</mat-form-field>

												<div class="max-h-[250px]">
													<ng-container *ngFor="let category of categoryList">
														<mat-option
															(click)="
																getSubCategoryList('', category.id);
																categoryvalue = category
															"
															[value]="category?.id"
														>
															{{
																translate.currentLang == 'en'
																	? category?.name?.en
																	: category?.name?.ar
															}}
														</mat-option>
													</ng-container>
													<mat-option
														disabled
														class="only-check"
														*ngIf="!categoryList?.length"
													>
														{{
															'STORE.ADD_PRODUCT.NO_CATEGORY_FOUND' | translate
														}}
													</mat-option>
												</div>
											</div>
										</mat-select>
									</mat-form-field>
								</div>
								<!-- CATEGORY  -->
								<!-- SUB CATEGORY -->

								<div class="w-[49%]">
									<h1
										class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
									>
										{{ 'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate }}
									</h1>
									<mat-form-field
										appearance="outline"
										class="w-full custom-autocomplete"
									>
										<mat-select
											panelClass=" my-0 mx-24px  {{
												editMode
													? 'custom-ed-hight'
													: 'custom-hight custom-width'
											}} "
											placeholder="{{
												'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate
											}}"
											formControlName="subCategoryId"
										>
											<mat-select-trigger class="text-main-color-black">
												{{
													getController('subCategoryId')?.value
														? this.translate.currentLang == 'en'
															? subCategory?.name?.en
															: subCategory?.name?.ar
														: ''
												}}
											</mat-select-trigger>
											<div class="select-container">
												<mat-form-field
													class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
													appearance="outline"
												>
													<div>
														<img
															class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
															src="./assets/images/search-normal.svg"
															alt=""
														/>
													</div>
													<input
														matInput
														type="text"
														(keydown)="$event.stopPropagation()"
														[formControl]="subCategoryKeyWord"
														placeholder="{{ 'OFFERS.SEARCH' | translate }}"
														class="absolute w-[92%] ltr:left-10 rtl:right-10"
													/>
													<img
														*ngIf="subCategoryKeyWord.value"
														(click)="subCategoryKeyWord.setValue('')"
														class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
														src="./assets/images/close-square.svg"
														alt=""
													/>
												</mat-form-field>

												<div class="max-h-[250px]">
													<ng-container
														*ngFor="let category of subCategoryList"
													>
														<mat-option
															(click)="
																getSubSubCategoryList(
																	'',
																	getController('subCategoryId').value
																);
																subCategory = category
															"
															[value]="category?.id"
														>
															{{
																translate.currentLang == 'en'
																	? category?.name?.en
																	: category?.name?.ar
															}}
														</mat-option>
													</ng-container>
													<mat-option
														disabled
														class="only-check"
														*ngIf="!subCategoryList?.length"
													>
														{{
															'STORE.ADD_PRODUCT.NO_SUB_CATEGORY_FOUND'
																| translate
														}}
													</mat-option>
												</div>
											</div>
										</mat-select>
									</mat-form-field>
								</div>

								<!-- SUB CATEGORY -->
							</div>
							<!-- Category & Brand FORM GROUP  -->
							<!-- SUB SUB CATEGORY  -->
							<div class="flex justify-between">
								<div class="w-[49%]">
									<h1
										class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
									>
										{{ 'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate }}
									</h1>

									<mat-form-field
										appearance="outline"
										class="w-full custom-autocomplete"
									>
										<mat-select
											panelClass=" my-0 mx-24px  {{
												editMode
													? 'custom-ed-hight'
													: 'custom-hight custom-width'
											}} "
											placeholder="{{
												'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate
											}}"
											formControlName="subSubcategoryId"
										>
											<mat-select-trigger class="text-main-color-black">
												{{
													getController('subSubcategoryId')?.value
														? this.translate.currentLang == 'en'
															? subSubCategory?.name?.en
															: subSubCategory?.name?.ar
														: ''
												}}
											</mat-select-trigger>
											<div class="select-container">
												<mat-form-field
													class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
													appearance="outline"
												>
													<div>
														<img
															class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
															src="./assets/images/search-normal.svg"
															alt=""
														/>
													</div>
													<input
														matInput
														type="text"
														(keydown)="$event.stopPropagation()"
														[formControl]="subSubCategoryKeyWord"
														placeholder="{{ 'OFFERS.SEARCH' | translate }}"
														class="absolute w-[92%] ltr:left-10 rtl:right-10"
													/>
													<img
														*ngIf="subSubCategoryKeyWord.value"
														(click)="subSubCategoryKeyWord.setValue('')"
														class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
														src="./assets/images/close-square.svg"
														alt=""
													/>
												</mat-form-field>

												<div class="max-h-[250px]">
													<mat-option
														(click)="subSubCategory = category"
														*ngFor="let category of subSubCategoryList"
														[value]="category.id"
													>
														{{
															translate.currentLang == 'en'
																? category?.name?.en
																: category?.name?.ar
														}}
													</mat-option>
													<mat-option
														disabled
														class="only-check"
														*ngIf="!subSubCategoryList?.length"
													>
														{{
															'STORE.ADD_PRODUCT.NO_SUB_SUB_CATEGORY_FOUND'
																| translate
														}}
													</mat-option>
												</div>
											</div>
										</mat-select>
									</mat-form-field>
								</div>
								<!-- SUB SUB CATEGORY  -->
								<!-- BRANDS  -->
								<div class="w-[49%]">
									<h1
										class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
									>
										{{ 'STORE.ADD_PRODUCT.BRAND' | translate }}
									</h1>

									<mat-form-field
										appearance="outline"
										class="w-full custom-autocomplete"
									>
										<mat-select
											panelClass=" my-0 mx-24px  {{
												editMode
													? 'custom-ed-hight'
													: 'custom-hight custom-width'
											}} "
											placeholder="	{{ 'STORE.ADD_PRODUCT.BRAND' | translate }}"
											formControlName="brandId"
										>
											<mat-select-trigger class="text-main-color-black">
												{{
													getController('brandId')?.value
														? this.translate.currentLang == 'en'
															? selectedBrand?.name?.en
															: selectedBrand?.name?.ar
														: ''
												}}
											</mat-select-trigger>
											<div class="select-container">
												<mat-form-field
													class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
													appearance="outline"
												>
													<div>
														<img
															class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
															src="./assets/images/search-normal.svg"
															alt=""
														/>
													</div>
													<input
														matInput
														type="text"
														(keydown)="$event.stopPropagation()"
														[formControl]="brandKeyWord"
														placeholder="{{ 'OFFERS.SEARCH' | translate }}"
														class="absolute w-[92%] ltr:left-10 rtl:right-10"
													/>
													<img
														*ngIf="brandKeyWord.value"
														(click)="brandKeyWord.setValue('')"
														class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
														src="./assets/images/close-square.svg"
														alt=""
													/>
												</mat-form-field>

												<div class="max-h-[250px]">
													<ng-container *ngFor="let brand of brandList">
														<mat-option
															[value]="brand.id"
															(click)="selectedBrand = brand"
														>
															{{
																translate.currentLang == 'en'
																	? brand?.name?.en
																	: brand?.name?.ar
															}}
														</mat-option>
													</ng-container>
													<mat-option
														disabled
														class="only-check"
														*ngIf="!brandList?.length"
													>
														{{
															'STORE.ADD_PRODUCT.NO_BRANDS_FOUND' | translate
														}}
													</mat-option>
												</div>
											</div>
										</mat-select>
									</mat-form-field>
								</div>
								<!-- BRANDS  -->
							</div>
						</div>
						<!-- INVENTORY PRICE  -->
						<!-- PRICE  -->
						<div *ngIf="!productHasVariances">
							<h1
								class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-12px"
							>
								{{ 'STORE.ADD_PRODUCT.PRICE_DISCOUNT' | translate }}
							</h1>

							<div
								class="py-12px px-24px rounded-12px bg-off-white sectionShadow mt-24px"
							>
								<h1
									class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
								>
									{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
								</h1>

								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
									</mat-label>
									<input
										(wheel)="$event.preventDefault()"
										formControlName="price"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="number"
										matInput
										maxlength="150"
										placeholder="{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}"
									/>
									<span class="text-dark-grey mx-2" matSuffix>
										{{
											getController('countryId')?.value == 103
												? ('CURRENCY.SAR' | translate)
												: ('CURRENCY.EGP' | translate)
										}}
									</span>
									<mat-error>
										<validation-message
											[controller]="getController('price')"
											controller_name="STORE.ADD_PRODUCT.PRICE"
										>
										</validation-message>
									</mat-error>
								</mat-form-field>
								<!-- PRICE  -->
								<!-- DISCOUNT  -->
								<h1
									class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-6px"
								>
									{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}
								</h1>
								<div class="mb-12px">
									<mat-radio-group
										(change)="getController('discountAmount')?.setValue('')"
										formControlName="isDiscountFixed"
									>
										<mat-radio-button
											[checked]="
												getController('isDiscountFixed')?.value == true
											"
											[value]="true"
											>{{
												'STORE.ADD_PRODUCT.FIXED_PRICE' | translate
											}}</mat-radio-button
										>
										<mat-radio-button [value]="false">{{
											'STORE.ADD_PRODUCT.PERCENTAGE' | translate
										}}</mat-radio-button>
									</mat-radio-group>
								</div>
								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}
									</mat-label>
									<input
										(wheel)="$event.preventDefault()"
										formControlName="discountAmount"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="number"
										matInput
										maxlength="150"
										placeholder="{{ 'STORE.ADD_PRODUCT.DISCOUNT' | translate }}"
									/>
									<span
										*ngIf="getController('isDiscountFixed')?.value == true"
										class="text-dark-grey mx-2"
										matSuffix
									>
										{{
											getController('countryId')?.value == 103
												? ('CURRENCY.SAR' | translate)
												: ('CURRENCY.EGP' | translate)
										}}
									</span>
									<span
										*ngIf="getController('isDiscountFixed')?.value == false"
										class="text-dark-grey mx-2"
										matSuffix
									>
										{{ '%' }}
									</span>
									<mat-error>
										<validation-message
											[controller]="getController('discountAmount')"
											controller_name="STORE.ADD_PRODUCT.DISCOUNT"
										>
										</validation-message>
									</mat-error>
									<mat-error
										*ngIf="
											this.productForm
												.get('discountAmount')
												?.hasError('discountMoreThanPrice')
										"
									>
										{{
											'VALIDATION.DISCOUNT_LESS_THAN_PRICE' | translate
										}}</mat-error
									>
									<mat-error
										*ngIf="
											this.productForm
												.get('discountAmount')
												?.hasError('percentageMax')
										"
									>
										{{
											'VALIDATION.DISCOUNT_PERCENTAGE_MAX' | translate
										}}</mat-error
									>
								</mat-form-field>
								<!-- DISCOUNT  -->
							</div>

							<div
								class="py-12px px-24px rounded-12px bg-off-white sectionShadow mt-24px"
							>
								<!-- SKU NUMBER  -->
								<h1
									class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
								>
									{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
								</h1>

								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.SKU' | translate }}
									</mat-label>
									<input
										(keyup)="checkUnique($event)"
										formControlName="skuNumber"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="text"
										matInput
										maxlength="150"
										placeholder="{{ 'STORE.ADD_PRODUCT.SKU' | translate }}"
									/>

									<mat-error>
										<validation-message
											[controller]="getController('skuNumber')"
											controller_name="STORE.ADD_PRODUCT.SKU"
										>
										</validation-message>
										<mat-error
											*ngIf="productForm.get('skuNumber')?.errors?.unique"
										>
											<span class="text-red-error text-font-12">{{
												'VALIDATION.SKU_UNIQUE' | translate
											}}</span>
										</mat-error>
									</mat-error>
								</mat-form-field>
								<!-- SKU NUMBER  -->

								<h1
									class="text-font-14 text-dark-grey font-DIN-Bold font-bold mb-12px"
								>
									{{ 'STORE.ADD_PRODUCT.STOCK_AVAILABILITY' | translate }}
								</h1>

								<mat-form-field class="w-full relative" appearance="outline">
									<mat-label class="text-dark-grey"
										>{{ 'STORE.ADD_PRODUCT.STOCK_AVAILABILITY' | translate }}
									</mat-label>
									<input
										(wheel)="$event.preventDefault()"
										formControlName="stockCount"
										class="text-font-16 text-[#4E4B66] w-[96%]"
										type="number"
										matInput
										placeholder="{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}"
									/>
									<span class="text-dark-grey mx-2" matSuffix>
										{{ 'STORE.ADD_PRODUCT.STOCK' | translate }}
									</span>
									<mat-error>
										<validation-message
											[controller]="getController('stockCount')"
											controller_name="STORE.ADD_PRODUCT.STOCK"
										>
										</validation-message>
									</mat-error>
								</mat-form-field>
								<!-- LOW QUANTITY  -->
								<div class="flex items-center">
									<mat-checkbox
										[checked]="getController('lowQuantity')?.value"
										formControlName="lowQuantity"
										class="rtl:ml-8px ltr:mr-8px"
									></mat-checkbox>
									<p class="m-0">
										{{ 'STORE.ADD_PRODUCT.LOW_QUANTITY' | translate }}
									</p>
								</div>
								<!-- LOW QUANTITY  -->
							</div>
						</div>
						<!-- INVENTORY PRICE  -->

						<!-- PRODUCT NOTE  -->
						<h1
							class="font-DIN-bold font-bold text-font-16 text-dark-grey my-16px"
						>
							{{ 'STORE.ADD_PRODUCT.PRODUCT_NOTE' | translate }}
						</h1>
						<div class="p-24px rounded-12px bg-off-white sectionShadow mt-24px">
							<mat-form-field class="w-full">
								<textarea
									maxlength="150"
									(keyup)="calculateLength($event)"
									formControlName="productNotes"
									class="textAreaResizeDisable relative p-4"
									matInput
									placeholder="{{
										'STORE.ADD_PRODUCT.PRODUCT_NOTE' | translate
									}}"
								></textarea>
								<p
									class="text-medium-gray text-font-16 absolute bottom-1 rtl:left-2 ltr:right-2"
								>
									{{ productNotesCount }}/150
								</p>
							</mat-form-field>
						</div>
						<!-- PRODUCT NOTE  -->
						<div *ngIf="productHasVariances" class="mt-24px">
							<app-product-variance
								[hasVariants]="this.productHasVariances"
								[variantsData]="
									productDetails?.productVariants && productDetails?.hasVariant
										? productDetails?.productVariants
										: []
								"
								[countryId]="getController('countryId')?.value"
								(productsVariantsEmitter)="
									getController('productVariants').setValue($event)
								"
								[editMode]="editMode"
								[addMode]="addMode"
							></app-product-variance>
						</div>
						<!-- UNCOMMENT WHEN NEEDED -->
						<!-- LINKED PRODUCTS  -->
						<!-- <div class="my-24px">
							<ng-container *ngIf="showLinkedProductDropDown">
								<h1
									class="text-dark-grey text-font-16 font-DIN-bold font-bold mb-12px"
								>
									{{ 'STORE.ADD_PRODUCT.LINKED_PRODUCTS' | translate }}
								</h1>

								<mat-form-field
									appearance="outline"
									class="w-full custom-autocomplete my-12px"
								>
									<mat-select
										#relatedProductSelect
										[multiple]="true"
										panelClass=" my-0 mx-24px  {{
											editMode ? 'custom-ed-hight' : 'custom-hight custom-width'
										}} "
										placeholder="{{
											'STORE.ADD_PRODUCT.LINKED_PRODUCTS' | translate
										}}"
										formControlName="tempRelatedProducts"
									>
										<mat-select-trigger class="text-main-color-black">
											{{ 'STORE.ADD_PRODUCT.LINKED_PRODUCTS' | translate }}
										</mat-select-trigger>
										<div class="select-container">
											<mat-form-field
												class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
												appearance="outline"
											>
												<div>
													<img
														class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
														src="./assets/images/search-normal.svg"
														alt=""
													/>
												</div>
												<input
													matInput
													type="text"
													(keydown)="$event.stopPropagation()"
													[formControl]="relatedProductsKeyWord"
													placeholder="{{ 'OFFERS.SEARCH' | translate }}"
													class="absolute w-[92%] ltr:left-10 rtl:right-10"
												/>
												<img
													*ngIf="relatedProductsKeyWord.value"
													(click)="relatedProductsKeyWord.setValue('')"
													class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
													src="./assets/images/close-square.svg"
													alt=""
												/>
											</mat-form-field>

											<div class="max-h-[350px] relative">
												<mat-option
													*ngFor="let product of productList"
													[value]="product"
												>
													{{
														translate.currentLang == 'en'
															? product?.name?.en
															: product?.name?.ar
													}}
												</mat-option>
												<div
													class="sticky bottom-0 w-full bg-light-grey"
													*ngIf="productList.length > 0"
												>
													<div class="flex w-full justify-between px-2">
														<button
															(click)="
																takeAction('cancel');
																relatedProductSelect.close()
															"
															class="border-[1px] w-[48%] border-secondry-color-Gray text-dark-grey rounded-[6px] py-[15px] bg-light-grey"
														>
															{{ 'ACTIONS.CANCEL' | translate }}
														</button>
														<button
															mat-button
															[disabled]="
																this.getController('tempRelatedProducts')?.value
																	?.length == 0 ||
																this.getController('tempRelatedProducts')
																	?.value == null
															"
															(click)="takeAction('link')"
															class="bg-gradient w-[48%] text-off-white rounded-[6px] py-[25px]"
														>
															{{ 'GENERAL_LABELS.LINK' | translate }}
														</button>
													</div>
												</div>
												<mat-option
													disabled
													class="only-check"
													*ngIf="!productList?.length"
												>
													{{ 'STORE.ADD_PRODUCT.NO_PRODUCT_FOUND' | translate }}
												</mat-option>
											</div>
										</div>
									</mat-select>
								</mat-form-field>
							</ng-container>
						
							<div class="my-12px" *ngIf="showLinkedProductTable">
								<div class="flex justify-between">
									<h1
										class="text-dark-grey text-font-16 font-DIN-bold font-bold mb-12px"
									>
										{{ 'STORE.ADD_PRODUCT.LINKED_PRODUCTS' | translate }}
									</h1>
									<button (click)="showLinkedProductDropDown = true">
										<img
											class="inline-block"
											src="./assets/images/add-blue.svg"
											alt=""
										/>
										<span class="text-link">{{
											'ACTIONS.ADD' | translate
										}}</span>
									</button>
								</div>
								
								<div
									class="custom-table overflow-x-auto"
									*ngIf="getController('relatedProducts').value.length > 0"
								>
									<table
										class="mat-elevation-z8 bg-transparent w-full relative"
									>
										<thead class="bg-light">
											<tr class="border-b-[1px] border-secondry-color-Gray">
												<td
													class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
												>
													{{ 'STORE.ADD_PRODUCT.PRODUCT_NAME' | translate }}
												</td>

												<td
													class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
												>
													{{ 'STORE.ADD_PRODUCT.PRICE' | translate }}
												</td>
												<td
													class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
												>
													{{ 'STORE.ADD_PRODUCT.QUANTITY' | translate }}
												</td>
												<td
													class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
												>
													{{ 'STORE.ADD_PRODUCT.STATUS' | translate }}
												</td>
												<td></td>
											</tr>
										</thead>
										<tbody class="bg-grey-background">
											<tr *ngFor="let product of linkedProductsDisplay">
												<td
													class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
												>
													<span
														class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
													>
														<img
															[src]="attachmentUrl + product?.mainImageUrl"
															alt=""
															class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
														/>
														<span>
															<span
																class="block whitespace-normal text-dark-grey"
															>
																{{
																	translate.currentLang == 'en'
																		? product?.name?.en
																		: product?.name?.ar
																}}
															</span>
														</span>
													</span>
												</td>

												<td
													class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular"
												>
													<h1
														class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
													>
														{{
															translate.currentLang == 'en'
																? product?.currency?.name?.en
																: product?.currency?.name?.ar
														}}
														{{ product?.price }}
													</h1>
												</td>
												<td
													class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
												>
													{{ product?.stockCount }}
												</td>
												<td
													class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
												>
													<app-status
														[enumData]="productActivationStatus"
														[statusValue]="product?.isActive ? 1 : 0"
													></app-status>
												</td>

												<td
													(click)="openDialog(product)"
													class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
												>
													<span
														class="inline-block max-mobile:w-[20px] w-[16px] text-end cursor-pointer"
													>
														<svg width="16" height="16" viewBox="0 0 16 16">
															<path
																d="M13.3391 9.65212L12.0456 9.21558C11.7223 9.11857 11.3827 9.31259 11.2857 9.61979C11.2049 9.92699 11.3504 10.2504 11.6576 10.3635L12.9511 10.8001C13.2744 10.9133 13.614 10.7354 13.711 10.412C13.808 10.0887 13.6625 9.7653 13.3391 9.65212Z"
																fill="#4E4B66"
															/>
															<path
																d="M10.1537 5.51295C9.91122 5.27042 9.53935 5.27042 9.29682 5.51295L5.86912 8.95682C5.64276 9.19935 5.65893 9.58739 5.90145 9.81375C6.12781 10.0239 6.49969 10.0239 6.72604 9.81375L10.1537 6.36988C10.3801 6.12735 10.3801 5.75548 10.1537 5.51295Z"
																fill="#4E4B66"
															/>
															<path
																d="M10.7194 11.333C10.6062 11.0096 10.2667 10.8479 9.95946 10.945C9.63609 11.0581 9.47441 11.3977 9.57142 11.7049L10.008 12.9983C10.1211 13.3217 10.4607 13.4834 10.784 13.3702C11.1074 13.257 11.2691 12.9175 11.1559 12.5941L10.7194 11.333Z"
																fill="#4E4B66"
															/>
															<path
																d="M5.28731 3.99259C5.38432 4.31596 5.72385 4.49381 6.04722 4.3968C6.37059 4.29979 6.54844 3.96026 6.45143 3.63689C6.45143 3.62072 6.43526 3.60455 6.43526 3.58838L5.99872 2.29491C5.88554 1.97154 5.546 1.80986 5.2388 1.90687C4.9316 2.00388 4.75375 2.35958 4.85076 2.66678L5.28731 3.99259Z"
																fill="#4E4B66"
															/>
															<path
																d="M2.668 5.65814L3.96147 6.09469C4.28484 6.20787 4.62438 6.03002 4.72139 5.70665C4.83457 5.38328 4.65672 5.04374 4.33335 4.94673L3.03987 4.52635C2.71651 4.41318 2.37697 4.59103 2.27996 4.9144C2.18295 5.23776 2.3608 5.56113 2.668 5.65814Z"
																fill="#4E4B66"
															/>
															<path
																d="M8.44002 4.65598L10.1539 2.94213C10.8653 2.23072 12.0132 2.23072 12.7247 2.94213C13.4361 3.65354 13.4361 4.8015 12.7247 5.51291L11.0108 7.22676C10.7683 7.45312 10.7521 7.84116 10.9785 8.08369C11.2048 8.32621 11.5929 8.34238 11.8354 8.11602C11.8516 8.09986 11.8516 8.09985 11.8677 8.08369L13.5816 6.36983C14.8104 5.23804 14.9074 3.314 13.7756 2.0852C12.6438 0.856402 10.7198 0.759391 9.49097 1.89118C9.4263 1.95585 9.36162 2.02053 9.29695 2.0852L7.5831 3.79905C7.34057 4.02541 7.3244 4.41345 7.55076 4.65598C7.77712 4.89851 8.16516 4.91468 8.40768 4.68832C8.42385 4.68832 8.42385 4.67215 8.44002 4.65598Z"
																fill="#4E4B66"
															/>
															<path
																d="M6.72611 13.2416L8.43996 11.5278C8.66632 11.2853 8.65015 10.8972 8.40762 10.6709C8.18126 10.4607 7.80939 10.4607 7.58303 10.6709L5.86918 12.3847C5.15777 13.0961 4.00981 13.0961 3.2984 12.3847C2.58699 11.6733 2.58699 10.5253 3.2984 9.81393L5.01225 8.0839C5.23861 7.84138 5.22244 7.45334 4.97992 7.22698C4.75356 7.01679 4.38168 7.01679 4.15533 7.22698L2.44147 8.957C1.30968 10.1858 1.40669 12.1098 2.63549 13.2416C3.78345 14.2926 5.56198 14.2926 6.72611 13.2416Z"
																fill="#4E4B66"
															/>
														</svg>
													</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								
							</div> 
						

							
						</div> -->
						<!-- LINKED PRODUCTS  -->
						<button
							*ngIf="editMode && (!addMode || !viewMode)"
							mat-button
							class="w-full text-red-error cancelRedBtn my-24px"
						>
							DELETE PRODUCT
						</button>
						<div class="mt-24px">
							<button
								(click)="editMode ? updateProductDetails(false) : save()"
								[disabled]="productForm.invalid"
								mat-button
								class="bg-gradient text-off-white w-full mb-8px py-[20px]"
							>
								{{ 'ACTIONS.SAVE' | translate }}
							</button>
							<button
								(click)="cancelButtonNavigation()"
								mat-button
								class="cancelBtn w-full"
							>
								{{ 'ACTIONS.CANCEL' | translate }}
							</button>
						</div>
					</form>
				</ng-container>
				<!-- EDIT SECTION  -->
			</div>
		</section>
	</ng-container>
	<!-- DETAILS SECTION  -->
</main>
